import { TFunction } from 'i18next';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FC } from 'react';

type Props = {
  value: string;
  onChange: (value: string) => void;
  onAdd: () => void;
  t: TFunction;
};

const CategorizationInput: FC<Props> = ({ value, onChange, onAdd, t }) => (
  <div
    style={{
      marginTop: '1rem',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      marginRight: '1rem',
    }}
  >
    <label
      style={{
        fontWeight: 'bold',
        flex: 1,
      }}
    >
      {t('otherIncidentManagement.incidentDetail.categorizacion')}
    </label>

    <InputText
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ flex: 6, width: '60%' }}
    />

    <Button label="Añadir" onClick={onAdd} style={{ flex: 2 }} disabled={!value.trim()} />
  </div>
);
export default CategorizationInput;
